import { jsx as p, jsxs as X } from "react/jsx-runtime";
import B from "classnames";
import { forwardRef as Y, useState as Z, useRef as M, useMemo as U, useImperativeHandle as F, useCallback as l, cloneElement as W } from "react";
import a from "./index.es5530.js";
import { selectIconColor as I } from "./index.es776.js";
import { UtilityCloseIcon as K } from "./index.es456.js";
import { useOnClickOutside as C, useOnKeyPress as R } from "@placer-ui/hooks";
import { mergeRefs as tt } from "./index.es551.js";
const nt = Y(
  ({
    size: O = "default",
    LeftIcon: m,
    RightIcon: n,
    disabled: d,
    testId: N,
    isError: b = !1,
    disableCloseIcon: i = !1,
    allowRightIconClick: g = !1,
    value: q,
    rightIconPosition: x = "0px",
    shouldBlurOnEnter: L = !0,
    required: A,
    onChange: s,
    onClear: f,
    onFocus: v,
    onEnterKeyPress: h,
    ...S
  }, D) => {
    const [w, u] = Z(!1), e = M(null), T = M(null), y = U(() => {
      const t = {
        outline: I("primary-brand", !!d)
      };
      return d ? { ...t, color: "outline", outline: "disabled" } : t;
    }, [d]);
    F(
      D,
      () => ({
        focus() {
          var t;
          (t = e == null ? void 0 : e.current) == null || t.focus();
        },
        blur() {
          var t;
          (t = e == null ? void 0 : e.current) == null || t.blur();
        },
        addEventListener(t, r, c) {
          var o;
          (o = e == null ? void 0 : e.current) == null || o.addEventListener(t, r, c);
        },
        removeEventListener(t, r, c) {
          var o;
          (o = e == null ? void 0 : e.current) == null || o.removeEventListener(t, r, c);
        },
        ...e.current
      }),
      []
    );
    const _ = l(
      (t) => {
        t.stopPropagation(), s == null || s(""), f == null || f(), u(!1), setTimeout(() => {
          var r, c;
          (c = (r = e == null ? void 0 : e.current) == null ? void 0 : r.focus) == null || c.call(r);
        }, 200);
      },
      [s, f]
    ), E = l(
      (t) => {
        const { value: r } = t.target;
        r.length ? u(!i && !0) : u(!1), s == null || s(r);
      },
      [s, i]
    ), G = l(
      (t) => {
        t.target.value.length && u(!i && !0), v == null || v(t);
      },
      [i, v]
    ), j = l(
      (t) => {
        setTimeout(() => {
          u(!1);
        }, 20);
      },
      []
    ), J = l((t) => {
      u(!1);
    }, []);
    C(J, T);
    const P = l(
      (t) => {
        var r;
        h == null || h(), L && ((r = e.current) == null || r.blur());
      },
      [h, L]
    );
    R("Enter", P, e.current);
    const $ = l(
      (t) => {
        t.preventDefault();
      },
      []
    ), z = l(() => {
      setTimeout(() => {
        u(!0);
      }, 20);
    }, []), k = B(a.rightIcon, {
      [a.allowedClick]: g,
      [a.clearButtonInvisible]: !w && !n
    }), H = U(() => n && !w ? /* @__PURE__ */ p(
      "div",
      {
        className: k,
        tabIndex: -1,
        style: { right: x },
        "data-type": "input-field-right-icon",
        children: W(n, y)
      }
    ) : i ? null : /* @__PURE__ */ p(
      "button",
      {
        className: k,
        onClick: _,
        onPointerDown: $,
        "data-testid": `${N}-close-icon`,
        style: { right: x },
        onFocus: z,
        onBlur: j,
        "data-type": "input-field-right-icon",
        "aria-hidden": !w,
        type: "button",
        children: /* @__PURE__ */ p(K, { "aria-label": "clear all icon" })
      }
    ), [
      n,
      k,
      i,
      j,
      z,
      _,
      $,
      x,
      y,
      w,
      N
    ]), Q = B(a.inputWrapper, {
      [a.hasLeftIcon]: !!m,
      [a.hasRightIcon]: !!H
    }), V = B(a.input, a[`input--size-${O}`]);
    return /* @__PURE__ */ X("div", { className: Q, ref: T, "data-identifier": "input-wrapper", children: [
      m && /* @__PURE__ */ p(
        "div",
        {
          className: a.leftIcon,
          tabIndex: -1,
          "data-type": "input-field-left-icon",
          children: W(m, y)
        }
      ),
      /* @__PURE__ */ p(
        "input",
        {
          className: V,
          type: "text",
          onChange: E,
          value: q,
          disabled: d,
          required: A,
          "aria-invalid": b,
          "data-testid": N,
          ref: tt(D, e),
          onFocus: G,
          pattern: S.pattern,
          "data-is-error": b,
          "data-size": O,
          "data-has-right-icon": !!n,
          "data-has-left-icon": !!m,
          "data-has-clear-button": !i,
          ...S
        }
      ),
      H
    ] });
  }
);
export {
  nt as BaseInput
};
//# sourceMappingURL=index.es677.js.map
